/*
  The path file defines all the path
*/

export const path = {
  dashboard: '/',
  project: '/p/:project_textid'
};
